import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import { useContext, useEffect, useState } from "react";
import { AdminService } from "../../../Services/Admin.service";
import Toaster from "../../../Components/Toaster";
import Rest from '../../../Services/Rest';
import TokenService from '../../../Services/Token.service';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ConfirmationModal from "../../../Components/ConfirmationModal";
import UserProfileDetails from "../../../Components/AdministrativeSettings/UserProfileDetails";
import Loader from "../../../Components/Loader";

function AdminProfile() {

    
const checkIfExists = (column, value) => {
    if(value!==adminData.email){ 
    return Rest.post(`/user/exists`, { column, value })
        .then(response => response.data.exists)
        .catch(error => {
            console.error('Error checking if exists:', error);
            return false;
        });
    }
    return Promise.resolve(false);
};
// Validation schema using Yup
const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    middle_name: Yup.string().required('Middle Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    email: Yup.string()
        .email('Invalid email format')
        // .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Invalid email address')
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
        .required('Email is required')
        // .test('email-unique', 'Email already exists', function (value) {
        //     if (!value) return true;
        //     return checkIfExists('email', value).then((exists) => {
        //         return !exists;
        //     });

        // })
        ,
    phone_number: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone Number must be 10 digits')
        .required('Phone Number is required'),
    gender: Yup.string().required('Gender is required'),

});

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        handleDeleteUser(adminData.id);
        handleCloseDeleteModal();
    };

    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const confirmDeactivateUser = () => {
        handleChangeStatus(adminData, adminData.active);
        handleCloseDeactivateModal();
    };


    const navigate = useNavigate();

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    // const { id } = useParams();
    const location = useLocation();
    const [adminData, setAdminData] = useState(location.state?.admin);
    const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);
    const [userMenu, setUserMenu] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [adminMenuList, setAdminMenuList] = useState([]);
    const previousUrl = TokenService.getPrevLink();
    const [navigateToRequestor, setNavigateToRequestor] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAdminMenuList = () => {
            AdminService.getAdminMenuList()
                .then((menuList) => {
                    setAdminMenuList(menuList.menu);
                })
                .catch((err) => {
                    if (err.response && err.response.status === 404) {
                        setToastMessage('Permission list not found.');
                        setToastVariant('error');
                        setShowToast(true);
                    } else {
                        setToastMessage('Failed to get permission list. Please contact administrator.');
                        setToastVariant('error');
                        setShowToast(true);
                    }
                })
        };
        const fetchUserDetails = async (userId) => {
            try {
                const userDetails = await AdminService.getUserDetails(userId);
                setUserMenu(userDetails.menus);
                const newCheckedItems = {};

                userDetails.menus.forEach(menu => {
                    menu.user_access.forEach(access => {
                        newCheckedItems[access.slug] = true; // Set the slug to true
                    });
                });

                setCheckedItems(newCheckedItems);
            } catch (error) {
                console.error("Failed to fetch user details", error);
            }
        };
        fetchUserDetails(adminData.id);
        fetchAdminMenuList();
    }, [adminData.id, adminData]);


    // State for checkboxes
    const [adminControlsChecked, setAdminControlsChecked] = useState(false);
    const [adminSettingsChecked, setAdminSettingsChecked] = useState(false);

    const [sampleRequestsChecked, setSampleRequestsChecked] = useState(false);
    const [donorManagementChecked, setDonorManagementChecked] = useState(false);
    const [donationReportsChecked, setDonationReportsChecked] = useState(false);
    const [appointmentDurationsAndCompensationChecked, setAppointmentDurationsAndCompensationChecked] = useState(false);

    const [labHoursChecked, setLabHoursChecked] = useState(false);
    const [adminManagementChecked, setAdminManagementChecked] = useState(false);
    const [requestorManagementChecked, setRequestorManagementChecked] = useState(false);
    const [emailSmsManagementChecked, setEmailSmsManagementChecked] = useState(false);

    // Handle toggle for Admin Controls
    const handleAccessPermissionChange = (event, slug, isParent) => {
        const isChecked = event.target.checked;

        if (isParent) {
            // If the parent is checked/unchecked, update all children accordingly
            setCheckedItems((prev) => {
                const newCheckedItems = { ...prev };
                newCheckedItems[slug] = isChecked; // Update the parent checkbox

                // Update all children checkboxes
                const parentMenuItem = adminMenuList.find(item => item.slug === slug);
                if (parentMenuItem && parentMenuItem.children) {
                    parentMenuItem.children.forEach(child => {
                        newCheckedItems[child.slug] = isChecked; // Set all children's state to parent's state
                    });
                }

                return newCheckedItems;
            });
        } else {
            // Update the state for a child checkbox
            setCheckedItems((prev) => {
                const newCheckedItems = { ...prev, [slug]: isChecked }; // Update state for the specific child

                // Check if any sibling child checkboxes are checked
                const parentSlug = adminMenuList.find(item => item.children && item.children.some(child => child.slug === slug))?.slug;
                if (parentSlug) {
                    const parentMenuItem = adminMenuList.find(item => item.slug === parentSlug);
                    const anyChildChecked = parentMenuItem.children.some(child => newCheckedItems[child.slug]); // Check if any child is checked

                    // Update parent's checked state based on children's states
                    newCheckedItems[parentSlug] = anyChildChecked; // If any child is checked, check the parent
                }

                return newCheckedItems;
            });
        }
    };


    const handleDeleteUser = async (userId) => {
        try {
           
            const response = await AdminService.deleteAdminUser(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("User deleted successfully:", response);
                setTimeout(() => {
                    // administrative-settings
                    navigate('/admin/admin-management');
                }, 2000);
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to delete user:", error);
        }
    };

    const handleChangeStatus = async (admin, status) => {
        setLoading(true);
        const newStatus = admin.active ? 0 : 1;
        try {
            const response = await AdminService.changeUserStatus(admin.id, newStatus);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                const userDetails = await AdminService.getUserDetails(adminData.id);
                setAdminData(userDetails.user);
                setLoading(false); 
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false); 
            }
        } catch (error) {
            setToastMessage("Failed to change user status");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change user status:", error);
            setLoading(false); 
        }
    };
    const handleSubmit = async (values, { resetForm, setSubmitting, setFieldError }) => {
        const emailExists = await checkIfExists('email', values.email);
        if (emailExists) {
            setFieldError('email', 'Email already exists');
            setSubmitting(false);
            return;
        }
        
        setLoading(true);
        const is_superadmin = values.is_superadmin;
        const menu_access = Object.keys(checkedItems).filter(slug => checkedItems[slug]);
        const requestorData = {
            user_id: adminData.id,
            first_name: values.first_name,
            middle_name: values.middle_name,
            last_name: values.last_name,
            phone_number: values.phone_number,
            gender: values.gender,
            sequence: 1,
            email: values.email,
            user_type: [is_superadmin],
            menu_access: menu_access
        };

        try {
           
            const data = await AdminService.updateUserDetails(requestorData);
            if (!data.success) {
                setToastMessage(data.error);
                setToastVariant('error');
            } else {
                // resetForm();
                setToastMessage(data.message);
                setToastVariant('success');

                setNavigateToRequestor(true);
            }
        } catch (error) {
            setToastMessage('Failed to update admin details.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            setShowToast(true);
        }
    };

    useEffect(() => {
        if (navigateToRequestor) {
            const timer = setTimeout(() => {
                // administrative-settings
                navigate('/admin/admin-management');
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [navigateToRequestor]);
    
    const handlePermissionSubmit = async () => {
        try {
            let menu_access = [];
            menu_access = Object.keys(checkedItems).filter(slug => checkedItems[slug]);
            const response = await AdminService.manageUserPermissions(adminData.id, menu_access);

            if (response.success == true) {
                setToastMessage(response.message);
                setToastVariant("success");
                setShowToast(true);
            } else {
                setToastMessage(response.message);
                setToastVariant("error");
                setShowToast(true);
            }

        } catch (error) {
            setToastMessage("Failed to update user permissions.");
            setToastVariant("danger");
            setShowToast(true);
        }
    };
    return (
        <>
             <Loader loading={loading}/>
            {/* <h1>{id}</h1> */}
            {/* <div className={`el-middle ${!isSidebarVisible ? 'collapsed-body' : ''}`}> */}
            <div className="el-middle-wrapper">
                <h2 className="el-title">Admin Profile</h2>
                <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Admin Management</Link>

              {/* <UserProfileDetails userType="admin" userData={adminData} handleChangeStatus={handleChangeStatus} handleShowDeleteModal={handleShowDeleteModal}/> */}
              <UserProfileDetails userType="admin" userData={adminData}  handleChangeStatus={handleShowDeactivateModal}  handleShowDeleteModal={handleShowDeleteModal}/>
                <div className="">    
                {/* el-profile-board el-bg-table */}
                    <>
                        <div className="el-bg-table el-super-admin mt-5">
                            <Formik
                                initialValues={adminData}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                                enableReinitialize={true} // Enable reinitialization when initialValues change
                            >
                                {({ errors, touched }) => (
                                    <Form>
                                        <div className="row mt-3 mt-md-0 col-xl-12">
                                            {/* 'username', 'email', 'password', 'confirm_password', */}
                                            {['first_name', 'middle_name', 'last_name','email', 'phone_number'].map(field => (
                                                <div className="col-md-4" key={field}>
                                                    <label htmlFor={field} className="form-label">
                                                        {field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                                                        <span className="text-red">*</span>
                                                    </label>
                                                    <Field
                                                        // type={field.includes('password') ? 'password' : 'text'}
                                                        type={field.includes('password') ? 'password' : field === 'phone_number' ? 'number' : 'text'}
                                                        maxLength={field === 'phone_number' ? 10 : undefined}
                                                        onInput={(e) => {
                                                            if (field === 'phone_number' && e.target.value.length > 10) {
                                                                e.target.value = e.target.value.slice(0, 10);
                                                            }
                                                            else if(field == 'email'){ 
                                                                e.target.value = e.target.value.replace(/\s/g, '').slice(0, 50);
                                                            }
                                                            else {
                                                                // e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').slice(0, 50);
                                                                e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 50);
                                                            }
                                                        }}
                                                        name={field}
                                                        className={`form-control ${field === 'phone_number' ? 'no-arrows' : ''}`}
                                                        placeholder={`Enter ${field
                                                            .replace(/_/g, ' ')
                                                            .trim()
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                                    />
                                                    <ErrorMessage name={field} component="div" className="text-danger" />
                                                </div>
                                            ))}
                                            {/* Gender Radio Buttons */}
                                            <div className="col-md-4 ">
                                                <label className="form-label">Biological Sex<span className="text-red">*</span></label>
                                                <div className="d-flex justify-content-between  mt-3  ms-3 w-40">
                                                    {['XY', 'XX'].map((gender) => (
                                                        <div className="form-check " key={gender}>
                                                            <Field id={`biological_sex_${gender}`} type="radio" name="gender" value={gender} className="form-check-input radio-pointer" />
                                                            <label htmlFor={`biological_sex_${gender}`} className="form-check-label radio-pointer">&nbsp; {gender}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                                <ErrorMessage name="gender" component="div" className="text-danger" />
                                            </div>
                                        </div>


                                        {!adminData.is_superadmin && (
                                            <div className="">
                                                {/* el-profile-board mt-5 */}
                                                {/* <div className="el-card-content"> */}
                                                <div className="mt-3">
                                                    <h3 className="mb-3">Select Admin Permissions</h3>
                                                    <div className="row mt-3">
                                                        {adminMenuList.map((menuItem, index) => (
                                                            <div key={index} className="col-md-5 mt-3">
                                                                <div className="form-check mb-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={!!checkedItems[menuItem.slug]}
                                                                        onChange={(e) => handleAccessPermissionChange(e, menuItem.slug, true)}
                                                                        id={menuItem.slug}
                                                                        value={menuItem.slug}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="{menuItem.slug}">
                                                                        {menuItem.name}
                                                                    </label>
                                                                </div>

                                                                {/* Nested Loop for children */}
                                                                {menuItem.children && menuItem.children.length > 0 && (
                                                                    <div className="row child-wrapper">
                                                                        {menuItem.children.map((childItem) => (
                                                                            <div className="child-menu-permission col-md-12">
                                                                                <div className="form-check mb-3">
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        checked={!!checkedItems[childItem.slug]}
                                                                                        onChange={(e) => handleAccessPermissionChange(e, childItem.slug)}
                                                                                        id={childItem.slug}
                                                                                        value={childItem.slug}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor="{childItem.slug}">
                                                                                        {childItem.name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>

                                                        ))}
                                                    </div>
                                                    <div className="d-flex my-5 w-f-content justify-content-center  ">
                                                        {/* <button type="button" className="btn  el-filled-btn" onClick={() => { handlePermissionSubmit() }}>Save changes</button>
                                        <Link className="back-link btn el-filled-btn" to={`${previousUrl}/admin-management`}>Close</Link> */}
                                                    </div>
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        )}
                                        <div className="d-flex align-items-center ">
                                        <button type="submit" className="el-main-button me-3"> <span>Save changes</span> </button>
                                        <Link className="back-link ms-3" to={`${previousUrl}`}>Close</Link></div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </>
                </div>
            </div>
            {/* </div> */}
            {/* Delete Confirmation Modal */}
            <ConfirmationModal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onConfirm={confirmDeleteUser}
                title="Confirm Delete"
                body="Are you sure you want to delete this user?"
            />
            {/* Deactivate Confirmation Modal */}
            <ConfirmationModal
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmDeactivateUser}
                title=""
                body={`Are you sure you want to ${adminData.active ? 'deactivate' : 'activate'} user?`}
                type='deactivateactivate'
            />
            {/* Reusable Toaster */}
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </>
    );
}

export default AdminProfile;